var cov_2jasq126zv = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tree/List.tsx",
      hash = "8a9b4f86c8dc33eb8dd2a2896a98aa7cfb166a0f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tree/List.tsx",
    statementMap: {
      "0": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 16
        }
      },
      "1": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 57
        }
      },
      "2": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 58
        }
      },
      "3": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 48
        }
      },
      "4": {
        start: {
          line: 35,
          column: 32
        },
        end: {
          line: 35,
          column: 42
        }
      },
      "5": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 61
        }
      },
      "6": {
        start: {
          line: 36,
          column: 38
        },
        end: {
          line: 36,
          column: 61
        }
      },
      "7": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 35
        }
      },
      "8": {
        start: {
          line: 37,
          column: 16
        },
        end: {
          line: 37,
          column: 35
        }
      },
      "9": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 39
        }
      },
      "10": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 19
        }
      },
      "11": {
        start: {
          line: 46,
          column: 81
        },
        end: {
          line: 46,
          column: 91
        }
      },
      "12": {
        start: {
          line: 47,
          column: 15
        },
        end: {
          line: 47,
          column: 56
        }
      },
      "13": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 59,
          column: 5
        }
      },
      "14": {
        start: {
          line: 63,
          column: 68
        },
        end: {
          line: 63,
          column: 78
        }
      },
      "15": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 51
        }
      },
      "16": {
        start: {
          line: 65,
          column: 40
        },
        end: {
          line: 65,
          column: 51
        }
      },
      "17": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 27
        }
      },
      "18": {
        start: {
          line: 68,
          column: 21
        },
        end: {
          line: 68,
          column: 87
        }
      },
      "19": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 49
          },
          end: {
            line: 32,
            column: 3
          }
        },
        line: 26
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        },
        loc: {
          start: {
            line: 34,
            column: 40
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 34
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        loc: {
          start: {
            line: 41,
            column: 61
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 41
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 45,
            column: 45
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 45
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        loc: {
          start: {
            line: 62,
            column: 11
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 62
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 35,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 35,
            column: 17
          },
          end: {
            line: 35,
            column: 19
          }
        }],
        line: 35
      },
      "1": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 61
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 61
          }
        }],
        line: 36
      },
      "2": {
        loc: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 35
          }
        }, {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 35
          }
        }],
        line: 37
      },
      "3": {
        loc: {
          start: {
            line: 38,
            column: 17
          },
          end: {
            line: 38,
            column: 30
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 38,
            column: 22
          },
          end: {
            line: 38,
            column: 25
          }
        }, {
          start: {
            line: 38,
            column: 28
          },
          end: {
            line: 38,
            column: 30
          }
        }],
        line: 38
      },
      "4": {
        loc: {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 51
          }
        }, {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 51
          }
        }],
        line: 65
      },
      "5": {
        loc: {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 17
          }
        }, {
          start: {
            line: 65,
            column: 21
          },
          end: {
            line: 65,
            column: 38
          }
        }],
        line: 65
      },
      "6": {
        loc: {
          start: {
            line: 68,
            column: 57
          },
          end: {
            line: 68,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 68
          },
          end: {
            line: 68,
            column: 75
          }
        }, {
          start: {
            line: 68,
            column: 78
          },
          end: {
            line: 68,
            column: 84
          }
        }],
        line: 68
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tree/List.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { treeClass } from './styles';
import { empty } from '../utils/func';
import Node from './Node';

var List =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(List, _PureComponent);

  var _super = _createSuper2(List);

  function List(props) {
    var _this;

    _classCallCheck(this, List);

    cov_2jasq126zv.f[0]++;
    cov_2jasq126zv.s[0]++;
    _this = _super.call(this, props);
    _this.bindLines = void 0;
    _this.bindList = void 0;
    _this.lines = void 0;
    _this.element = void 0;
    _this.hasExpanded = void 0;
    cov_2jasq126zv.s[1]++;
    _this.bindLines = _this.bindElement.bind(_assertThisInitialized(_this), 'lines');
    cov_2jasq126zv.s[2]++;
    _this.bindList = _this.bindElement.bind(_assertThisInitialized(_this), 'element');
    cov_2jasq126zv.s[3]++;
    _this.renderNode = _this.renderNode.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(List, [{
    key: "getKey",
    value: function getKey(data, index) {
      cov_2jasq126zv.f[1]++;

      var _ref = (cov_2jasq126zv.s[4]++, this.props),
          _ref$id = _ref.id,
          id = _ref$id === void 0 ? (cov_2jasq126zv.b[0][0]++, '') : _ref$id,
          keygen = _ref.keygen;

      cov_2jasq126zv.s[5]++;

      if (typeof keygen === 'function') {
        cov_2jasq126zv.b[1][0]++;
        cov_2jasq126zv.s[6]++;
        return keygen(data, id);
      } else {
        cov_2jasq126zv.b[1][1]++;
      }

      cov_2jasq126zv.s[7]++;

      if (keygen) {
        cov_2jasq126zv.b[2][0]++;
        cov_2jasq126zv.s[8]++;
        return data[keygen];
      } else {
        cov_2jasq126zv.b[2][1]++;
      }

      cov_2jasq126zv.s[9]++;
      return id + (id ? (cov_2jasq126zv.b[3][0]++, ',') : (cov_2jasq126zv.b[3][1]++, '')) + index;
    }
  }, {
    key: "bindElement",
    value: function bindElement(name, el) {
      cov_2jasq126zv.f[2]++;
      cov_2jasq126zv.s[10]++;
      this[name] = el;
    }
  }, {
    key: "renderNode",
    value: function renderNode(child, index) {
      cov_2jasq126zv.f[3]++;

      var _ref2 = (cov_2jasq126zv.s[11]++, this.props),
          data = _ref2.data,
          isRoot = _ref2.isRoot,
          expanded = _ref2.expanded,
          keygen = _ref2.keygen,
          line = _ref2.line,
          className = _ref2.className,
          style = _ref2.style,
          other = _objectWithoutProperties(_ref2, ["data", "isRoot", "expanded", "keygen", "line", "className", "style"]);

      var id = (cov_2jasq126zv.s[12]++, this.getKey(child, index));
      cov_2jasq126zv.s[13]++;
      return (
        /*#__PURE__*/
        React.createElement(Node, Object.assign({}, other, {
          data: child,
          id: id,
          index: index,
          key: id,
          line: line,
          keygen: keygen,
          listComponent: List,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49,
            columnNumber: 7
          }
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_2jasq126zv.f[4]++;

      var _ref3 = (cov_2jasq126zv.s[14]++, this.props),
          data = _ref3.data,
          expanded = _ref3.expanded,
          className = _ref3.className,
          style = _ref3.style,
          childrenClassName = _ref3.childrenClassName;

      cov_2jasq126zv.s[15]++;

      if ((cov_2jasq126zv.b[5][0]++, !expanded) && (cov_2jasq126zv.b[5][1]++, !this.hasExpanded)) {
        cov_2jasq126zv.b[4][0]++;
        cov_2jasq126zv.s[16]++;
        return null;
      } else {
        cov_2jasq126zv.b[4][1]++;
      }

      cov_2jasq126zv.s[17]++;
      this.hasExpanded = true;
      var newStyle = (cov_2jasq126zv.s[18]++, Object.assign({}, style, {
        display: expanded ? (cov_2jasq126zv.b[6][0]++, 'block') : (cov_2jasq126zv.b[6][1]++, 'none')
      }));
      cov_2jasq126zv.s[19]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(className, childrenClassName),
          ref: this.bindList,
          onDrop: empty,
          onDragOver: empty,
          style: newStyle,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 71,
            columnNumber: 7
          }
        }, data.map(this.renderNode))
      );
    }
  }]);

  return List;
}(PureComponent);

List.defaultProps = {
  id: '',
  line: true,
  className: treeClass('children')
};
export default List;